import { defineComponent, openBlock, createElementBlock, createStaticVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "ImagePrev"
});
const _hoisted_1 = {
  width: "40px",
  height: "40px",
  viewBox: "0 0 40 40",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-676.000000, -20.000000)"><g transform="translate(620.000000, 20.000000)"><g transform="translate(56.000000, 0.000000)"><rect fill="#2C364E" x="0" y="0" width="40" height="40" rx="20"></rect><g transform="translate(13.000000, 13.500000)" fill="#BDC3CD"><path d="M5.52424989,0.160938456 L0.125926538,6.17036026 C-0.0419706273,6.35726364 -0.0419761457,6.64229666 0.125913782,6.82920666 L5.52418931,12.8390473 C5.70438661,13.039659 6.01154311,13.0548023 6.21024254,12.8728708 L6.24382011,12.8389621 L6.24382011,12.8389621 L6.98958384,12.0083202 C7.1573678,11.8214401 7.15736675,11.5365345 6.98958142,11.3496557 L3.7344366,7.72408461 L13.5143091,7.72575508 C13.7527443,7.72586954 13.9510795,7.55244479 13.9922423,7.32369818 L14,7.23547292 L14,7.23547292 L14,5.76437755 C14,5.49357065 13.7825346,5.27403262 13.5143091,5.27397587 L3.7344366,5.27323973 L6.98939464,1.64989283 C7.1572951,1.46298977 7.15730212,1.17795405 6.98941087,0.991042567 L6.24379143,0.160952657 C6.06359412,-0.039659018 5.75643763,-0.0548023009 5.5577382,0.127129188 L5.52424989,0.160938456 L5.52424989,0.160938456 Z"></path></g></g></g></g></g>', 1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var imagePrev = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { imagePrev as default };
